/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */


exports.onRouteUpdate = () => {
  // Push route change event for GTM - wrap inside a timeout to ensure the title has properly been changed
  setTimeout(() => {
    window.dataLayer.push({ event: `gatsby-route-change` })
  }, 50)
};


exports.onInitialClientRender = () => {
  // defer loading of 3rd party scripts

  // One Trust
  let oneTrustScript = document.createElement('script');
  oneTrustScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  oneTrustScript.type = "text/javascript";
  oneTrustScript.charset = "UTF-8";
  oneTrustScript.setAttribute('data-domain-script', 'c696c240-1508-4550-b4f4-e0fbff88e8d3');

  let oneTrustPopup = document.createElement('script');
  oneTrustPopup.type = "text/javascript";
  oneTrustPopup.text = "function OptanonWrapper() { }";

  document.head.appendChild(oneTrustScript);
  document.head.appendChild(oneTrustPopup);


  // Google Tag Manager
  let gtmScript = document.createElement('script');
  gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-PF6FV6');`;

  let gtmNoscript = document.createElement('noscript');
  gtmNoscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PF6FV6" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

  document.head.appendChild(gtmScript);
  document.body.prepend(gtmNoscript);


  // Drift
  let driftScript = document.createElement('script');
  driftScript.innerHTML = `
  "use strict";

  !function() {
    var t = window.driftt = window.drift = window.driftt || [];
    if (!t.init) {
      if (t.invoked) return void (window.console && console.error && console.error("Drift snippet included twice."));
      t.invoked = !0, t.methods = [ "identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on" ],
      t.factory = function(e) {
        return function() {
          var n = Array.prototype.slice.call(arguments);
          return n.unshift(e), t.push(n), t;
        };
      }, t.methods.forEach(function(e) {
        t[e] = t.factory(e);
      }), t.load = function(t) {
        var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
        o.type = "text/javascript", o.async = !0, o.crossorigin = "anonymous", o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js";
        var i = document.getElementsByTagName("script")[0];
        i.parentNode.insertBefore(o, i);
      };
    }
  }();
  drift.SNIPPET_VERSION = '0.3.1';
  drift.load('k9itpxdev2n7');`;

  document.head.appendChild(driftScript);

  /**
   * Wistia Player Privacy Mode https://wistia.com/support/developers/player-privacy-mode
   * Setting to 'false' will enable Privacy Mode (anonymous tracking / GDPR-compliant) https://wistia.com/support/developers/player-privacy-mode#disable-tracking-for-a-single-visitor
   **/
  window._wq = window._wq || [];
  window._wq.push(function (W) {
    if( W.consent() === false ) {

      return;
    }

    W.consent(false);
  });

  if (process.env.NODE_ENV === `production`) {

    // FullStory
    let fsScript = document.createElement('script');
    fsScript.innerHTML = `
    window['_fs_debug'] = false;
    window['_fs_host'] = 'fullstory.com';
    window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
    window['_fs_org'] = 'Y48XN';
    window['_fs_namespace'] = 'FS';
    (function(m,n,e,t,l,o,g,y){
        if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
        g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
        o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
        y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
        g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
        g.anonymize=function(){g.identify(!!0)};
        g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
        g.log = function(a,b){g("log",[a,b])};
        g.consent=function(a){g("consent",!arguments.length||a)};
        g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
        g.clearUserCookie=function(){};
        g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
        if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
        g._v="1.2.0";
    })(window,document,window['_fs_namespace'],'script','user');`;
    document.head.appendChild(fsScript);
  }

  return null;
};

exports.onClientEntry = () => {

  /* eslint-disable */
  // MDN Polyfills

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith#Polyfill
  if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(search, this_len) {
      if (this_len === undefined || this_len > this.length) {
        this_len = this.length;
      }
      return this.substring(this_len - search.length, this_len) === search;
    };
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        'use strict';
        if (target === null || target === undefined) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource !== null && nextSource !== undefined) {
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;

      do {
        if (Element.prototype.matches.call(el, s)) return el;

        el = el.parentElement || el.parentNode;

      } while (el !== null && el.nodeType === 1);

      return null;
    };
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#Polyfill
  if (!Object.entries) {
    Object.entries = function( obj ){
      var ownProps = Object.keys( obj ),
          i = ownProps.length,
          resArray = new Array(i); // preallocate the Array
      while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];

      return resArray;
    };
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/append#Polyfill
  (function (arr) {
    arr.forEach(function (item) {

      if (item.hasOwnProperty('append')) {
        return;
      }

      Object.defineProperty(item, 'append', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: function append() {
          var argArr = Array.prototype.slice.call(arguments);
          var docFrag = window.document.createDocumentFragment();

          argArr.forEach(function (argItem) {

            var isNode = argItem instanceof Node;

            docFrag.appendChild(isNode ? argItem : window.document.createTextNode(String(argItem)));

          });

          this.appendChild(docFrag);
        }

      });
    });
  })([Element.prototype, Document.prototype, DocumentFragment.prototype]);

  /* eslint-enable */
}

